// TODO: unit tests missing...
const REDUX_ACTION_MESSAGE = 'members_area.store_action';

const send = (message) => {
  if (parent === window) {
    window.postMessage(JSON.stringify(message), '*');
  } else {
    for (let i = 0, l = parent.frames.length; i < l; i++) {
      parent.frames[i].postMessage(JSON.stringify(message), '*');
    }
    parent.postMessage(JSON.stringify(message), '*');
  }
};

const getMessageData = (message) => {
  try {
    return JSON.parse(message.data);
  } catch (e) {
    return {};
  }
};

/**
 * expect redux-type action to be received
 * @param store
 */
export const listenToFrames = (store) => {
  window.addEventListener('message', (message) => {
    const { type, action } = getMessageData(message);
    if (type === REDUX_ACTION_MESSAGE) {
      store.dispatch(action);
    }
  });
};

const createMessage = (action) => ({ type: REDUX_ACTION_MESSAGE, action });

export const sendActionToFrames = (action) => send(createMessage(action));

export const sendActionsToFrames = (actions) => actions.forEach(sendActionToFrames);
